import React, { useState } from "react";
import logo from "./../../assets/logoins.png";
import { ButtonStyle } from "../../utils/Buttons/Buttons";
import Radio from "@mui/material/Radio";
import {useHistory} from 'react-router-dom'


import "./SFinalAfiliacion.scss";

function SFinalAfiliacion() {
  const history = useHistory();
  
  const NextOptions= () => {
    history.push('./coociquedata'+ history.location.search)
  };
  return (
    <div className="screen1">
      <div className="box_one" style={{marginBottom:'2em', marginTop: "20vh"}}>
        <p className="title1">¡Excelente!</p>
        <p className="title2">Ha sido afiliado de <br/> forma exitosa.</p>
      </div>

   
     
    </div>
  );
}
export default SFinalAfiliacion;
